import { stockApi } from '$api'
import { IStocktake, Stocktake } from '$models'
import { getActiveCompanySettings } from '$utils'

export const createStocktake = async (
  newStocktake: IStocktake
): Promise<IStocktake> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return {}

  return await stockApi.createStocktake(new Stocktake(newStocktake))
}
